import { render, staticRenderFns } from "./DockLeft.vue?vue&type=template&id=63b80298"
import script from "./DockLeft.vue?vue&type=script&lang=js"
export * from "./DockLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports